import makeStyles from '@mui/styles/makeStyles'
import * as colors from '@mui/material/colors'

const cardShape = 'polygon(0% 0%, 100% 0%, 100% calc(100% - 25px), calc(100% - 25px) 100%, 0% 100%)'

export const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {

  },
  title: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '24px'
  },
  message: {
    marginLeft: spacing(1),
    lineHeight: '24px'
  },
  card: {
    clipPath: cardShape,
    display: 'flex',
    borderRadius: 0,
    background: '#FEF0E8',
    color: '#000',
    padding: '24px 16px',
    '& #newsletter-form': {
      flexDirection: 'column'
    }
  },
  edge: {
    width: '280px',
    paddingRight: 1,
    paddingBottom: 1,
    clipPath: cardShape,
    backgroundColor: palette.grey.shade[20]
  },
  subscribeButton: {
    backgroundColor: palette.info.main,
    color: palette.info.contrastText,
    '&:hover': {
      backgroundColor: palette.info.dark
    }
  },
  subscribedButton: {
    backgroundColor: colors.green[500],
    color: '#FFF',
    '&:hover': {
      backgroundColor: colors.green[600]
    }
  }
}))
